export const StylesHelper = {
  MOBILE: '(max-width: 720px)',
  TABLET: '(max-width: 1024px)',
  DESKTOP: '(min-width: 1920px)',
}
